import React, {PureComponent} from "react"

import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {CircleContainer, BigLink} from "../styled"

/** @todo We no longer have packages, need a proper picker */
// const DIAMOND_PROMO_LINK_KEY = "setup_tenant.steps.promo.diamondHref"
// const PREMIUM_PROMO_LINK_KEY = "setup_tenant.steps.promo.premiumHref"
// const PLATINUM_PROMO_LINK_KEY = "setup_tenant.steps.promo.platinumHref"
const DEFAULT_PROMO_LINK_KEY = "setup_tenant.steps.promo.defaultHref"

interface Props extends InjectIntl {
  setIsStepCompletable: (value: boolean) => void
}

class PromoMaterials extends PureComponent<Props> {
  componentDidMount() {
    this.props.setIsStepCompletable(true)
  }

  render() {
    const {formatMessage} = this.props
    const promoLink = formatMessage({id: DEFAULT_PROMO_LINK_KEY})
    const step1 = formatMessage({id: "setup_tenant.steps.promo.step1"})
    const step2 = formatMessage({id: "setup_tenant.steps.promo.step2"})
    const step3 = formatMessage({id: "setup_tenant.steps.promo.step3"})

    return (
      <Flex direction="column" wrap="nowrap" alignContent="stretch">
        <CircleContainer data={[step1, step2, step3]} />
        <BigLink href={promoLink} target="_blank" uppercase={false}>
          <FormattedMessage id="setup_tenant.steps.promo.assetLink" />
        </BigLink>
      </Flex>
    )
  }
}

export default injectIntl(PromoMaterials)
